import React from "react";
import EditStationContainer from "containers/EditStation";

const EditStation = (props) => {
  return (
    <>
    <EditStationContainer   {...props}/>
    
    </>
  );
};

export default EditStation;
